/* 
@example 
    
    export const ENDPOINT_ACTION_NAME = "/endpoint-url"
*/

// @labX URL
export const LABX_URL = "/lite/v2/api/v3/orders";

// @ussd URL
export const USSD_URL = "/lite/v2/api/labx/boat";

// @call URL
export const CALL_URL = "/lite/v2/api/labx/boat";

// @boat URL
export const BOAT_URL = "/lite/v2/api/labx/boat";

// @ongoing URL
export const ONGOING_URL = "/lite/v2/api/v3/completed/orders";

// @override URL
export const OVERRIDE_URL = "/lite/v2/api/admin/overide/vendor";

// @cylinder URL
export const CYLINDER_URL = "/lite/v2/api/admin/cylinder/pending";

// @riders URL
export const RIDERS_URL = "/lite/v2/api/admin/dispatch/fetch/all";

// @overdue URL
export const OVERDUE_URL = "/lite/v2/api/ongoing/overdue";

// cancelled order
export const CANCELLED_ORDER_URL = "/lite/v2/api/admin/order/cancel/list";

// completed order
export const COMPLETED_ORDER_URL = "/lite/v2/api/admin/order/get/all";

// @completed URL
// export const ONGOING_URL = "/lite/v2/api/v3/completed/orders";

// @newOrder URL
export const NEW_ORDER_URL = "/lite/v2/api/labx/boat";

// @hospital URL
export const HOSPITAL_URL = "/lite/v2/api/order/hospitallist";

// @dispatch URL
export const DISPATCH_URL = "/lite/v2/api/dispatch/";

// @lab URL
export const LAB_URL = "/lite/v2/api/order/bloodbanklistonly";

// @close URL
export const CLOSE_ORDER_URL = "/lite/v2/api/v3/close";

// @return URL
export const RETURN_ORDER_URL = "/lite/v2/api/v3/return";

// @return URL
export const COMPLAIN_ORDER_URL = "/lite/v2/api/v3/complain";

// @processOrder
export const PROCESS_ORDER_URL = "/lite/v2/api/v3/precheck";

//  @get oxygen list
export const OXYGEN_URL = "/lite/v2/api/order/oxygenlist";

//  @track order
export const TRACK_ORDER_URL = "/lite/v2/api/v3/status/order/";

//  @order price
export const ORDER_PRICE_URL = "/lite/v2/api/v3/pricecheck";

export const RIDER_URL = "/lite/v2/api/admin/dispatch/fetch/all";

export const UPDATE_ORDER_URL = "/lite/v2/api/v3/edit/ongoing";

export const MAKE_CRADLE_REQUEST ="/lite/v2/api/admin/crade/request"

export const STOCKBANK_URL = "/lite/v2/api/v3/stockbankorder/product/";

export const VIEW_NOTIFICATION = "/lite/v2/api/admin/notifications";

export const NOTIFICATION_URL = "/lite/v2/api/admin/notifications";

